
import {
  Component, Prop, PropSync, Mixins,
} from 'vue-property-decorator';
import { ScheduledPickupItem } from '@/features/schedule-pickup/types';
import focusMixin from '@/features/common/mixins/focusMixin';

@Component
export default class CancelPickupModal extends Mixins(focusMixin) {
  @PropSync('show', { required: true }) syncedShow!: boolean;

  @Prop({ required: true }) pickup!: ScheduledPickupItem | null;

  @Prop({ required: false, default: false }) loading!: boolean;

  get fromCountryName(): string {
    if (!this.pickup?.fromAddress || !this.pickup.fromAddress.countryCode) return '';
    const countryInfo = this.$store.getters.getCountryFromCode(
      this.pickup.fromAddress.countryCode,
    );

    if (!countryInfo) return '';

    return countryInfo.country;
  }
}
